// components/FeedbackNavbar.js
import { Grid, Typography, Button, IconButton } from '@mui/material';
import React from 'react';
import { variants } from '../../../variants/variants';
import { FeedbackRounded, PlayArrow, PlayCircle, PlayCircleFilled, PlayCircleOutline } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import NavbarLayout from '../../../common/NavbarLayout';

const FeedbackNavbar = () => {
  const navigate = useNavigate();

  const handlePlayCredits = () => {
    navigate('/credit');
  };

  const handleNavigateBack = () => {
    navigate('/home')
  }

  return (
    <NavbarLayout handleNavigate={handleNavigateBack}>
    <Grid item display={'flex'} justifyContent={'space-between'} alignItems={'center'} width="100%">
      <Grid item display={'flex'} justifyContent={'start'}>
        <FeedbackRounded sx={variants.icon.active} />
        <Typography component={'div'} ml={1}>
          Feedbacks <Typography fontSize={variants.BODY}>Reach out to developers</Typography>
        </Typography>
      </Grid>
      {/* <IconButton
        variant="text"
        color="primary"
        onClick={handlePlayCredits}
        sx={{ backgroundColor: 'transparent', color: '#000', borderRadius: '12px' }}
      >
        <PlayCircleOutline />
      </IconButton> */}
    </Grid>
    </NavbarLayout>
  );
};

export default FeedbackNavbar;
